import React from 'react';

export const MobileEmoji = () => {
    return (
        <svg
            width="26"
            height="30"
            fill="none"
            aria-labelledby="mobile emoji"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id="mobileEmojiT">mobile emoji</title>
            <desc id="mobileEmojiD">
                A vector illustration of a mobile emoji
            </desc>
            <path
                opacity=".1"
                d="M18.89 29.838H7.11a1.875 1.875 0 0 1-1.874-1.875V4.17c0-1.035.839-1.875 1.875-1.875H18.89c1.035 0 1.875.84 1.875 1.875v23.793c0 1.035-.84 1.875-1.875 1.875Z"
                fill="#2626BC"
            />
            <path
                d="M18.89 28.338H7.11a1.875 1.875 0 0 1-1.874-1.875V2.67c0-1.035.839-1.875 1.875-1.875H18.89c1.035 0 1.875.84 1.875 1.875v23.793c0 1.035-.84 1.875-1.875 1.875Z"
                fill="#6583FE"
            />
            <path d="M5.236 3.477h15.529v22.179H5.235V3.477Z" fill="#2D58E0" />
            <path
                d="M11.952 11.62H8.768a.625.625 0 0 1-.625-.625V8.057c0-.346.28-.625.625-.625h3.184c.345 0 .625.28.625.625v2.938c0 .345-.28.625-.625.625ZM17.26 11.602h-3.185a.625.625 0 0 1-.625-.625V8.04c0-.345.28-.625.625-.625h3.184c.345 0 .625.28.625.625v2.938c0 .345-.28.625-.625.625ZM20.747 7.414v4.188H19.4a.625.625 0 0 1-.625-.625V8.04c0-.345.28-.625.625-.625h1.347Z"
                fill="#1F50C9"
            />
            <path
                d="M16.365 4.816h-6.73a.313.313 0 0 0 0 .625h6.73a.313.313 0 0 0 0-.625Z"
                fill="#fff"
            />
            <path
                d="M11.952 10.963H8.768a.625.625 0 0 1-.625-.625V7.4c0-.346.28-.625.625-.625h3.184c.345 0 .625.28.625.625v2.938c0 .345-.28.625-.625.625Z"
                fill="#FF7EB8"
            />
            <path
                d="M11.287 9.657H9.995a.313.313 0 0 0 0 .625h1.292a.312.312 0 1 0 0-.625ZM11.287 8.636h-.355a.313.313 0 0 0 0 .625h.355a.313.313 0 0 0 0-.625Z"
                fill="#fff"
            />
            <path
                d="M17.26 10.945h-3.185a.625.625 0 0 1-.625-.625V7.382c0-.345.28-.625.625-.625h3.184c.345 0 .625.28.625.625v2.938c0 .345-.28.625-.625.625Z"
                fill="#02FFB3"
            />
            <path
                d="M16.595 9.64h-1.293a.313.313 0 0 0 0 .624h1.293a.313.313 0 0 0 0-.625ZM16.595 8.619h-.355a.313.313 0 0 0 0 .625h.355a.313.313 0 0 0 0-.625Z"
                fill="#fff"
            />
            <path
                d="M20.747 6.757v4.188H19.4a.625.625 0 0 1-.625-.625V7.382c0-.345.28-.625.625-.625h1.347Z"
                fill="#9FB0FE"
            />
            <path
                d="M5.236 25.656V14.11c0-.863.7-1.563 1.562-1.563h12.404c.863 0 1.563.7 1.563 1.563v11.546H5.235Z"
                fill="#fff"
            />
            <path
                d="M18.89 28.65H7.11a2.19 2.19 0 0 1-2.187-2.187V2.67A2.19 2.19 0 0 1 7.111.483H18.89a2.19 2.19 0 0 1 2.187 2.187v23.793a2.19 2.19 0 0 1-2.187 2.187ZM7.11 1.108c-.861 0-1.562.7-1.562 1.562v23.793c0 .861.701 1.562 1.563 1.562H18.89c.861 0 1.562-.7 1.562-1.562V2.67c0-.861-.7-1.562-1.562-1.562H7.11Z"
                fill="#2626BC"
            />
            <path
                d="M14.093 2.506h-2.185a.313.313 0 0 1 0-.625h2.185a.313.313 0 0 1 0 .625ZM15.55 2.506a.313.313 0 1 0 0-.625.313.313 0 0 0 0 .625Z"
                fill="#B7C5FF"
            />
            <path
                d="M11.662 14.566H10.37a.313.313 0 0 0 0 .625h1.292a.312.312 0 1 0 0-.625Z"
                fill="#00D890"
            />
            <path
                d="M18.037 15.834H10.37a.313.313 0 0 0 0 .625h7.667a.312.312 0 1 0 0-.625Z"
                fill="#9FB0FE"
            />
            <path
                d="M8.558 16.459H7.291a.313.313 0 0 1-.312-.313v-1.267c0-.172.14-.313.312-.313h1.267c.173 0 .313.14.313.313v1.267c0 .173-.14.313-.313.313Z"
                fill="#02FFB3"
            />
            <path
                d="M11.662 18.438H10.37a.313.313 0 0 0 0 .625h1.292a.313.313 0 0 0 0-.625Z"
                fill="#FF5BA8"
            />
            <path
                d="M18.037 19.705H10.37a.313.313 0 0 0 0 .625h7.667a.312.312 0 1 0 0-.625Z"
                fill="#9FB0FE"
            />
            <path
                d="M8.558 20.33H7.291a.313.313 0 0 1-.312-.313V18.75c0-.172.14-.312.312-.312h1.267c.173 0 .313.14.313.312v1.267c0 .173-.14.313-.313.313Z"
                fill="#FF7EB8"
            />
            <path
                d="M11.662 22.31H10.37a.313.313 0 0 0 0 .624h1.292a.312.312 0 1 0 0-.625Z"
                fill="#6583FE"
            />
            <path
                d="M18.037 23.576H10.37a.313.313 0 0 0 0 .625h7.667a.312.312 0 1 0 0-.625ZM8.558 24.201H7.291a.313.313 0 0 1-.312-.312v-1.267c0-.173.14-.313.312-.313h1.267c.173 0 .313.14.313.313v1.267c0 .172-.14.312-.313.312Z"
                fill="#9FB0FE"
            />
            <path
                d="M23.146 23.828a.894.894 0 0 1 0-1.787.894.894 0 0 1 0 1.787Zm0-1.162a.268.268 0 1 0 0 .537.268.268 0 0 0 0-.537Z"
                fill="#6583FE"
            />
            <path
                d="M2.183 10.526a.313.313 0 0 1-.313-.313.375.375 0 0 0-.375-.375.313.313 0 0 1 0-.625.375.375 0 0 0 .375-.375.313.313 0 0 1 .625 0c0 .207.168.375.375.375a.313.313 0 0 1 0 .625.375.375 0 0 0-.375.375c0 .173-.14.313-.312.313ZM24.04 26.656a.312.312 0 0 1-.312-.313.375.375 0 0 0-.375-.375.312.312 0 1 1 0-.625.375.375 0 0 0 .375-.375.312.312 0 1 1 .625 0c0 .207.168.375.375.375a.312.312 0 1 1 0 .625.375.375 0 0 0-.375.375c0 .173-.14.313-.312.313Z"
                fill="#01ECA5"
            />
            <path
                d="M24.728 8.414a.312.312 0 0 1-.312-.313.375.375 0 0 0-.375-.375.312.312 0 1 1 0-.625.375.375 0 0 0 .375-.375.312.312 0 1 1 .625 0c0 .207.168.375.375.375a.313.313 0 0 1 0 .625.375.375 0 0 0-.375.375c0 .173-.14.313-.313.313ZM1.54 13.607a.313.313 0 0 1-.313-.313.375.375 0 0 0-.375-.375.313.313 0 0 1 0-.625.375.375 0 0 0 .375-.375.313.313 0 0 1 .625 0c0 .207.168.375.375.375a.313.313 0 0 1 0 .625.375.375 0 0 0-.375.375c0 .173-.14.313-.313.313Z"
                fill="#FF5BA8"
            />
        </svg>
    );
};
